export default __webpack_public_path__ + "static/media/vinho3.509c3176.jpg";